<template>
  <div class="home">
    <div class="navbar-container">
      <HeaderPo />

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <DescriptionContainer />
          </div>
          <div class="col-md-12 col-lg-12 mt-3" v-scroll-reveal.reset="{ delay: 0 }">
            <div class="d-flex justify-content-between align-items-center">
              <h3>Produk yang tersedia di PO ini</h3>
              <div class="form-group">
                <select class="custom-select">
                  <option selected>Urutkan berdasarkan</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select>
                <img
                  src="assets/img/icons/interface/icon-caret-down.svg"
                  alt="Arrow Down"
                  class="icon icon-sm"
                />
              </div>
              <div class="form-group">
                <input class="form-control" placeholder="Pencarian" type="text" />
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-3 mb-lg-5" v-scroll-reveal.reset="{ delay: 200 }">
            <div class="card hover-box-shadow">
              <a href="#" class="d-block bg-gradient rounded-top">
                <img
                  class="card-img-top hover-fade-out"
                  src="assets/img/products/product-01.png"
                  alt="blog.5.image"
                />
              </a>
              <div class="card-body">
                <h5>Soto Ayam Lamongan Cak Har Surabaya</h5>

                <p style="font-size: 12px;"></p>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="primary lead">
                    <strong>Rp 15,000</strong>
                  </p>
                  <a href="#" class="btn btn-sm btn-outline-primary-3">
                    <div class="d-flex align-items-center">
                      <span>Add to cart</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-5" v-scroll-reveal.reset="{ delay: 250 }">
            <div class="card hover-box-shadow" >
              <a href="#" class="d-block bg-gradient rounded-top">
                <img
                  class="card-img-top hover-fade-out"
                  src="assets/img/products/product-02.png"
                  alt="blog.5.image"
                />
              </a>
              <div class="card-body">
                <h5>Soto Ayam Lamongan Cak Har Surabaya</h5>

                <p style="font-size: 12px;"></p>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="primary lead">
                    <strong>Rp 15,000</strong>
                  </p>
                  <a href="#" class="btn btn-sm btn-outline-primary-3">
                    <div class="d-flex align-items-center">
                      <span>Add to cart</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-5" v-scroll-reveal.reset="{ delay: 300 }">
            <div class="card hover-box-shadow">
              <a href="#" class="d-block bg-gradient rounded-top">
                <img
                  class="card-img-top hover-fade-out"
                  src="assets/img/products/product-01.png"
                  alt="blog.5.image"
                />
              </a>
              <div class="card-body">
                <h5>Soto Ayam Lamongan Cak Har Surabaya</h5>

                <p style="font-size: 12px;"></p>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="primary lead">
                    <strong>Rp 15,000</strong>
                  </p>
                  <a href="#" class="btn btn-sm btn-outline-primary-3">
                    <div class="d-flex align-items-center">
                      <span>Add to cart</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-5" v-scroll-reveal.reset="{ delay: 350 }">
            <div class="card hover-box-shadow">
              <a href="#" class="d-block bg-gradient rounded-top">
                <img
                  class="card-img-top hover-fade-out"
                  src="assets/img/products/product-01.png"
                  alt="blog.5.image"
                />
              </a>
              <div class="card-body">
                <h5>Soto Ayam Lamongan Cak Har Surabaya</h5>

                <p style="font-size: 12px;"></p>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="primary lead">
                    <strong>Rp 15,000</strong>
                  </p>
                  <a href="#" class="btn btn-sm btn-outline-primary-3">
                    <div class="d-flex align-items-center">
                      <span>Add to cart</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-5" v-scroll-reveal.reset="{ delay: 400 }">
            <div class="card hover-box-shadow">
              <a href="#" class="d-block bg-gradient rounded-top">
                <img
                  class="card-img-top hover-fade-out"
                  src="assets/img/products/product-01.png"
                  alt="blog.5.image"
                />
              </a>
              <div class="card-body">
                <h5>Soto Ayam Lamongan Cak Har Surabaya</h5>

                <p style="font-size: 12px;"></p>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="primary lead">
                    <strong>Rp 15,000</strong>
                  </p>
                  <a href="#" class="btn btn-sm btn-outline-primary-3">
                    <div class="d-flex align-items-center">
                      <span>Add to cart</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-5" v-scroll-reveal.reset="{ delay: 450 }">
            <div class="card hover-box-shadow">
              <a href="#" class="d-block bg-gradient rounded-top">
                <img
                  class="card-img-top hover-fade-out"
                  src="assets/img/products/product-01.png"
                  alt="blog.5.image"
                />
              </a>
              <div class="card-body">
                <h5>Soto Ayam Lamongan Cak Har Surabaya</h5>

                <p style="font-size: 12px;"></p>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="primary lead">
                    <strong>Rp 15,000</strong>
                  </p>
                  <a href="#" class="btn btn-sm btn-outline-primary-3">
                    <div class="d-flex align-items-center">
                      <span>Add to cart</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-5" v-scroll-reveal.reset="{ delay: 500 }">
            <div class="card hover-box-shadow">
              <a href="#" class="d-block bg-gradient rounded-top">
                <img
                  class="card-img-top hover-fade-out"
                  src="assets/img/products/product-01.png"
                  alt="blog.5.image"
                />
              </a>
              <div class="card-body">
                <h5>Soto Ayam Lamongan Cak Har Surabaya</h5>

                <p style="font-size: 12px;"></p>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="primary lead">
                    <strong>Rp 15,000</strong>
                  </p>
                  <a href="#" class="btn btn-sm btn-outline-primary-3">
                    <div class="d-flex align-items-center">
                      <span>Add to cart</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PoSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import HeaderPo from "@/components/PoContainer/HeaderPo.vue";
import DescriptionContainer from "@/components/PoContainer/DescriptionContainer.vue";

import PoSection from "@/components/PoSection.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "DetailPo",
  components: {
    HeaderPo,
    DescriptionContainer,
    PoSection,
    FooterSection
  }
};
</script>

